import * as ajax from "../../actions/ajaxCounterActions";
import * as layoutActions from "../../actions/layoutActions";
import * as exception from "../../actions/exceptionActions";
import * as simulatieInfrastructuurActions from "../../actions/simulatieInfrastructuurActions";

import showToastr, { showToastrError, showToastrInfo, showToastrSuccess } from "../../util/toastr.js";

import * as queryString from "query-string";
import * as constants from "../../constants/DomainConstants";

import simulatieDossierApi from "../../api/simulatieDossierApi";
import simulatiePerInfrastructuurApi from "../../api/simulatiePerInfrastructuurApi";
import geographyApi from "../../api/geographyApi";

import mergeDeep from "../../util/mergeDeep";
import { getStore } from "../../store/configureStore";

export default class SimulatieDossierPageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		let simulatieDossierId = this.context.props.simulatieDossierId;
		if (!simulatieDossierId) {
			const parsedQueryString = queryString.parse(this.context.props.location.search);
			simulatieDossierId = parsedQueryString.id;
		}
		this.initLayout(simulatieDossierId);

		if (simulatieDossierId !== undefined) {
			if (!this.context.props.simulatieDossierLoaded) {
				this.getSimulatieDossier(simulatieDossierId);
			}
		}
		else
			this.getNewSimulatieDossier();
	}

	initLayout(simulatieDossierId) {
		const intro = "Het decreet voor ondersteuning van bovenlokale sportinfrastructuur geeft aan dat een subsidieaanvraag aan 9 minimale eisen moet voldoen en toetsing moet doorstaan die bepaalt of een subsidieaanvraag voldoende bovenlokaal is. De dossiers die deze fase van de procedure doorkomen, worden nadien overhandigd aan een beoordelingscommissie. Via deze simulator kan je nagaan of jouw project voldoende bovenlokaal is en een inschatting maken of aan de minimale eisen kan worden voldaan. Hiervoor gebruik je best de browser 'Google Crome', om foutmeldingen te voorkomen.";

		this.dispatch(layoutActions.loadSimulatieDossierPageLayout("Ontvankelijkheidscriteria", intro, simulatieDossierId, true));
	}

	reloadIfRecievedFromNew(nextProps) {
		if (this.context.props.isNew)
			if (this.context.props.simulatieDossierId !== nextProps.simulatieDossierId)
				this.getSimulatieDossier(nextProps.simulatieDossierId);
	}

	getSimulatieDossier(simulatieDossierId) {
		this.dispatch(ajax.started());
		return simulatieDossierApi.get(simulatieDossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				const dossier = response.data.item;

				if (dossier.simulatorDossierLocked) {
					this.redirector.goToSimulatieDossierClosed();
					return "abort";
				}

				this.context.setState({
					simulatieDossier: dossier,
					errors: response.data.validationResults
				});

				this.saveSimulatieInfrastructurenToStore(dossier.sportinfrastructurenInDeBuurt.filter(x => x.behoortTotMijnProject));

				const lengtegraad = dossier.lengtegraad;
				const breedtegraad = dossier.breedtegraad;
				if (lengtegraad && breedtegraad) {
					this.context.setState({
						newCoordinates: Object.assign({}, { lat: breedtegraad, lng: lengtegraad }),
						center: Object.assign({}, { lat: parseFloat(breedtegraad), lng: parseFloat(lengtegraad) })
					});
					this.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad); //necessary to make sure we have all the latest existing infras in de buurt
				}
				this.getSimulatieInfrastructuren(simulatieDossierId);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getNewSimulatieDossier() {
		this.dispatch(ajax.started());
		simulatieDossierApi.loadEmptySimulatieDossier()
			.then(response => {
				this.dispatch(ajax.ended());
				this.context.setState({
					simulatieDossier: response.data
				});
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	saveSimulatieInfrastructurenToStore(infrastructuren) {
		this.dispatch(simulatieInfrastructuurActions.saveInfrastructurenForDossier(infrastructuren));
	}

	addNewInfrastructuur() {
		return this.context.setState({
			addInfraModalIsOpen: true
		});
	}

	addNieuwbouwInfrastructuur() {
		return this.context.setState({
			addNieuwbouwInfraModalIsOpen: true
		});
	}

	cancelNieuwbouwInfrastructuur() {
		return this.context.setState({
			addNieuwbouwInfraModalIsOpen: false
		});
	}

	gotoAddNieuwbouwInfrastructuur(dossierId) {
		return simulatieDossierApi.loadEmptyInfrastructuur(dossierId)
			.then(result => {
				let empty = result.data;
				let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
				empty = Object.assign({}, empty, {
					breedtegraad: simulatieDossier.breedtegraad,
					lengtegraad: simulatieDossier.lengtegraad,
					straatHuisnummer: simulatieDossier.straatHuisnummer,
					postcode: simulatieDossier.postcode,
					gemeente: simulatieDossier.gemeente,
					simulatieDossierId: simulatieDossier.id
				});

				simulatieDossier.sportinfrastructurenInDeBuurt.push(empty);

				this.context.props.storeSimulatieDossier(simulatieDossier);
				this.context.setState({
					simulatieDossier: simulatieDossier,
					hasUnsavedChanges: true,
					selectedInfraId: empty.id
				}, () =>
					this.context.setState({ hasUnsavedChanges: false }, () => {
						this.redirector.goTo(`simulatiedossier/infra/${this.context.state.selectedInfraId}/add/infraNieuwbouw`);
					})
				);
			});
	}

	deleteNieuwbouwInfrastructuur(id) {
		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: true,
			nieuwbouwToRemoveId: id
		});
	}

	cancelDeleteNieuwbouwInfra() {
		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: false
		});
	}

	gotoDeleteNieuwbouwInfra() {
		const sportInfraId = this.context.state.nieuwbouwToRemoveId;
		let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		const infraindex = simulatieDossier.sportinfrastructurenInDeBuurt.indexOf(simulatieDossier.sportinfrastructurenInDeBuurt.find(x => x.id === sportInfraId));

		simulatieDossier.sportinfrastructurenInDeBuurt.splice(infraindex, 1);

		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: false,
			nieuwbouwToRemoveId: null,
			simulatieDossier: simulatieDossier,
			hasUnsavedChanges: true
		});
	}

	addNewInfrastructuurAndGoToEdit(dossierId) {
		return simulatieDossierApi.loadEmptyInfrastructuur(dossierId)
			.then(result => {
				let empty = result.data;
				let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
				empty = Object.assign({}, empty, {
					breedtegraad: simulatieDossier.breedtegraad,
					lengtegraad: simulatieDossier.lengtegraad,
					straatHuisnummer: simulatieDossier.straatHuisnummer,
					postcode: simulatieDossier.postcode,
					gemeente: simulatieDossier.gemeente,
					simulatieDossierId: simulatieDossier.id,
					initialisatieOK: true
				});

				simulatieDossier.sportinfrastructurenInDeBuurt.push(empty);

				this.context.props.storeSimulatieDossier(simulatieDossier);
				this.context.setState({
					simulatieDossier: simulatieDossier,
					hasUnsavedChanges: true,
					selectedInfraId: empty.id
				}, () =>
					this.context.setState({ hasUnsavedChanges: false }, () => {
						this.redirector.goTo(`simulatiedossier/infra/${this.context.state.selectedInfraId}/add/infraRenovatie`);
					})
				);
			});
	}

	isReadyToRender() {
		const { postcodes, gemeenten, soortenInfrastructuur } = this.context.props;
		const { simulatieDossier } = this.context.state;
		// entity not loaded? not ready yet...
		if (!simulatieDossier)
			return false;

		//Required reference data not loaded? Not ready
		if (postcodes.length < 0 || gemeenten.length < 0 || soortenInfrastructuur === null)
			return false;

		return true;
	}

	save(event, shouldRedirect = true) {
		if (event)
			event.preventDefault();

		this.dispatch(ajax.started());

		let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		if (simulatieDossier.verdwijnenErInfrastructuren && simulatieDossier.sportinfrastructurenInDeBuurt.filter(x => x.soortWerken !== constants.INFRASTRUCTUUR_TYPE.NIEUWBOUW).length <= 0) {
			simulatieDossier.verdwijnenErInfrastructurenNietInSpakki = true;
		}

		return simulatieDossierApi.save(simulatieDossier)
			.then((response) => {
				this.dispatch(ajax.ended());
				let result = null;
				if (response.data.concurrencyException) {
					this.context.setState({
						errors: response.data.validationResults
					});
					result = constants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.context.setState({
						errors: response.data.validationResults
					});
					result = constants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					//Necessary to have the validation on the correct item in the current working list of infrastructuren.
					//We have no way of sorting the list in the page and on the server the same way without using a tempId going to the server and back.
					// => decided to do this 'hack' instead of spending a lot of time on doing it the 'right' way
					//No risk of lost server data being ignored, since a concurrency error is thrown if this happens.
					this.context.setState({
						errors: response.data.validationResults
					});
					//const workingInfrastructuren = project.infrastructuren;
					//const updatedModelFromServer = Object.assign({}, response.data.item, { infrastructuren: workingInfrastructuren });

					result = constants.HAS_VALIDATION_ERRORS_SAVED_SIMULATIE;
				} else {
					this.context.setState({
						errors: null
					});
					result = constants.SUCCESS;
				}
				let isSaved = showToastr(result);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					this.initLayout(this.context.state.simulatieDossier.id);
					this.saveSimulatieInfrastructurenToStore(response.data.item.sportinfrastructurenInDeBuurt.filter(x => x.behoortTotMijnProject));
				}
				this.context.setState({
					infraRemoved: false,
					hasUnsavedChanges: false
				});
				this.context.props.storeSimulatieDossier(response.data.item);

				if (response.data.item.lengtegraad && response.data.item.breedtegraad)
					setTimeout(() => this.getInfrastructurenInDeBuurt(response.data.item.lengtegraad, response.data.item.breedtegraad), 0); //necessary to make sure we have all the latest existing infras in de buurt

				this.getSimulatieInfrastructuren(this.context.state.simulatieDossier.id);

				if ((result !== constants.HAS_VALIDATION_ERRORS) && this.context.props.isNew && shouldRedirect) {
					this.redirector.goTo("simulatiedossier/" + this.context.state.simulatieDossier.id + "/bevestiging");
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	change(event, data, i) {
		let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		let field = null;
		if (data) {
			field = data.name;

			if (i != null) {
				const replacedField = field.replace("" + i, "");
				simulatieDossier.sportinfrastructurenInDeBuurt[i][replacedField] = data.value;
			} else {
				if (field === "straatHuisnummer" || field === "gemeente" || field === "postcode") {
					simulatieDossier.lengtegraad = "";
					simulatieDossier.breedtegraad = "";
				}
				simulatieDossier[field] = data.value;
			}
		} else {
			field = event.target.name;
			if (i != null) {
				const replacedField = field.replace("" + i, "");
				let infraToUpdate = simulatieDossier.sportinfrastructurenInDeBuurt[i];
				if (replacedField === "deelVanAanvraag") {
					if (event.target.value === '0') {
						this.context.setState({
							infraModalIsOpen: true,
							selectedInfraId: infraToUpdate.id,
							hasUnsavedChanges: true
						});
					}
					else {
						if (this.isStatusGewijzigdVoorMelding(event.target.value, infraToUpdate[replacedField]))
							this.context.setState({
								infraRemoved: true,
								hasUnsavedChanges: true
							});

						infraToUpdate[replacedField] = event.target.value;
					}
				}
			} else {
				const value = field === "verdwijnenErInfrastructurenNietInSpakki" ? event.target.checked : event.target.value;
				simulatieDossier[field] = value;
			}
		}

		return this.context.setState({
			simulatieDossier: simulatieDossier,
			hasUnsavedChanges: true
		});
	}

	changeRenovatieTable(event, id) {
		const value = event.target.checked;
		const simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		const infra = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.id === id)[0];
		infra.deelVanAanvraag_original = infra.deelVanAanvraag;

		infra.soortWerken = value === "true" || value === true ? constants.INFRASTRUCTUUR_TYPE.RENOVATIE : null;
		infra.deelVanAanvraag = value === "true" || value === true ? "0" : "1";

		this.context.setState({
			changedInfrastructuur: infra.id,
			simulatieDossier: simulatieDossier,
			addRenovatieToProjectModalIsOpen: value === "true" || value === true,
			hasUnsavedChanges: value === "false" || value === false
		});
	}

	goToRenovatieInfrastructuurDetail() {
		const simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		this.context.props.storeSimulatieDossier(simulatieDossier);

		this.context.setState({
			hasUnsavedChanges: true
		}, () =>
			this.context.setState({ hasUnsavedChanges: false }, () => {
				this.redirector.goTo(`simulatiedossier/infra/${this.context.state.changedInfrastructuur}/edit`);
			})
		);
	}

	cancelRenovatieInfrastructuurDetail() {
		const simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		simulatieDossier.sportinfrastructurenInDeBuurt.find(x => x.id === this.context.state.changedInfrastructuur)["deelVanAanvraag"] = 1;
		return this.context.setState({
			addRenovatieToProjectModalIsOpen: false,
			simulatieDossier: simulatieDossier
		});
	}

	changeVerdwijnendeInfraTable(event, id, scrollY) {
		const value = event.target.checked;
		const simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		const infra = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.id === id)[0];

		if (value === "true" || value === true) {
			this.context.setState({
				simulatieDossier: simulatieDossier,
				hasUnsavedChanges: true,
				verdwijnendeInfra: infra.id,
				verdwijnendeInfraModalIsOpen: true,
				verdwijnendeInfraPosition: scrollY
			});
		} else {
			infra.deelVanAanvraag = "1";

			this.context.setState({
				simulatieDossier: simulatieDossier,
				hasUnsavedChanges: true
			});
		}
	}

	cancelVerdwijnendeInfra() {
		this.context.setState({
			verdwijnendeInfra: null,
			hasUnsavedChanges: true,
			verdwijnendeInfraModalIsOpen: false
		});
	}

	confirmVerdwijnendeInfra() {
		const simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		simulatieDossier.sportinfrastructurenInDeBuurt.find(x => x.id === this.context.state.verdwijnendeInfra).deelVanAanvraag = "2";

		this.context.setState({
			verdwijnendeInfra: null,
			simulatieDossier: simulatieDossier,
			hasUnsavedChanges: true,
			verdwijnendeInfraModalIsOpen: false
		});
	}

	changeSoortDossier(event) {
		let simulatieDossier = mergeDeep({}, this.context.state.simulatieDossier);
		const field = event.target.name;
		const value = event.target.value;

		let nieuwbouwModalOpen = value === constants.DOSSIER_SOORT_NIEUWBOUW.toString() || value === constants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString();

		simulatieDossier[field] = value;

		return this.context.setState({
			simulatieDossier: simulatieDossier,
			hasUnsavedChanges: true,
			nieuwbouwModalIsOpen: nieuwbouwModalOpen
		});
	}

	closeNieuwbouwModal() {
		this.context.setState({ nieuwbouwModalIsOpen: false });
	}

	isStatusGewijzigdVoorMelding(value, oldValue) {
		return ((oldValue == "0" || oldValue === 0) && (value == "1" || value === 1 || value == "2" || value === 2))
			|| ((oldValue == "1" || oldValue === 1) && (value == "2" || value === 2));
	}

	simuleer() {
		const infrastructuren = this.context.props.infrastructuren;
		let infrastructurenValidaties = [];
		let promises = [];

		infrastructuren.forEach(infra => {
			if (infra.id) { //Controle op lege guid (naam is dan null)
				this.dispatch(ajax.started());
				promises.push(simulatiePerInfrastructuurApi.getByInfrastructuurWithForcedValidation(infra.infrastructuurId)
					.then(response => {
						this.dispatch(ajax.ended());
						infrastructurenValidaties.push({
							id: infra.id,
							naam: infra.display,
							validation: response.data.hasValidationErrors ? response.data.validationResults : []
						});
					})
					.catch(error => {
						this.dispatch(ajax.failed(error));
						this.dispatch(exception.throwException(error));
					}));
			}
		});
		Promise.all(promises).then(() => {
			let nrOfErrors = this.context.state.errors ? Object.keys(this.context.state.errors).length : 0;
			let nrOfInfraErrors = 0;
			if (nrOfErrors > 0) {
				showToastrError("Je kunt nog niet simuleren. Er ontbreekt nog informatie op de pagina 'Algemeen'");
			}
			if (infrastructurenValidaties.length > 0)
				infrastructurenValidaties.forEach(infra => {
					if (infra.validation && Object.keys(infra.validation).length > 0) {
						nrOfInfraErrors += 1;
						showToastrError("Je kunt nog niet simuleren. Er ontbreekt nog informatie op de pagina '" + infra.naam + "'");
					}
				});
			if (nrOfErrors === 0 && nrOfInfraErrors === 0)
				this.redirector.goTo("simulatiedossier/resultaat/" + this.context.state.simulatieDossier.id);
		})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getGeoCoordinates(simulatieDossier) {
		let dossier = simulatieDossier ? simulatieDossier : this.context.state.simulatieDossier;

		let adres = {
			gemeenteId: dossier.gemeente,
			postcodeId: dossier.postcode,
			straatHuisnummer: dossier.straatHuisnummer
		};

		this.dispatch(ajax.started());
		geographyApi.getCoordinatenForAdres(adres).then(result => {
			this.dispatch(ajax.ended());
			const lengtegraad = result.data.lengtegraad;
			const breedtegraad = result.data.breedtegraad;
			if (lengtegraad && breedtegraad) {
				dossier.lengtegraad = lengtegraad;
				dossier.breedtegraad = breedtegraad;
				this.context.setState({
					simulatieDossier: dossier,
					newCoordinates: Object.assign({}, { lat: breedtegraad, lng: lengtegraad }),
					center: Object.assign({}, { lat: parseFloat(breedtegraad), lng: parseFloat(lengtegraad) })
				});
				this.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad); //necessary to make sure we have all the latest existing infras in de buurt
			} else {
				showToastr(constants.NO_GEOCOORDINATEN_FOUND);
			}
		});
	}

	getSimulatieInfrastructuren(dossierId) {
		this.dispatch(simulatieInfrastructuurActions.loadInfrastructurenByDossierId(dossierId));
	}

	getInfrastructurenInDeBuurt(lengtegraad, breedtegraad) {
		let simulatieDossierToUpdate = mergeDeep({}, this.context.state.simulatieDossier);
		this.dispatch(ajax.started());
		simulatieDossierApi.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad).then(infraResult => {
			this.dispatch(ajax.ended());

			let infrastructuren = infraResult.data.infrastructuren;

			const inEditMode = this.context.state.inEditMode;
			const sportinfrastructurenInDeBuurt = infrastructuren.filter(i => i.tienMinutenWandelen);
			const spakkiIdsVanSportinfrastructurenInDeBuurt = simulatieDossierToUpdate.sportinfrastructurenInDeBuurt.filter(s => s.spakki != null).map(s => s.spakki.id);

			const nieuweSportinfrastructurenInDeBuurt = sportinfrastructurenInDeBuurt.filter(s => s.spakki != null && !spakkiIdsVanSportinfrastructurenInDeBuurt.includes(s.spakki.id));

			// lijst van reeds opgeslagen infrastructuren en nieuwe infrastructuren in de buurt
			let sportinfrastructurenInDeBuurtReedsInProject = simulatieDossierToUpdate.sportinfrastructurenInDeBuurt.concat(nieuweSportinfrastructurenInDeBuurt);

			let sportinfrastructurenOpKaartReedsInProject = [];
			if (inEditMode == "false" || inEditMode === false) {
				sportinfrastructurenOpKaartReedsInProject = simulatieDossierToUpdate.sportinfrastructurenInDeBuurt.filter(i => i.deelVanAanvraag.toString() === constants.DeelVanAanvraag.Reconversie.toString() || i.deelVanAanvraag.toString() === constants.DeelVanAanvraag.Ja.toString()).concat(sportinfrastructurenInDeBuurt);
			}
			else {
				sportinfrastructurenOpKaartReedsInProject = sportinfrastructurenInDeBuurtReedsInProject;
			}

			const aangemaakteInfrasInDeBuurt = simulatieDossierToUpdate.sportinfrastructurenInDeBuurt.filter(i => i.tienMinutenWandelen && i.spakki == null);
			sportinfrastructurenOpKaartReedsInProject = sportinfrastructurenOpKaartReedsInProject.concat(aangemaakteInfrasInDeBuurt);

			if (simulatieDossierToUpdate.verdwijnenErInfrastructurenNietInSpakki &&
				simulatieDossierToUpdate.sportinfrastructurenInDeBuurt.filter(x => !!x.spakki).length <= 0 &&
				sportinfrastructurenInDeBuurt.length > 0) {
				simulatieDossierToUpdate.verdwijnenErInfrastructurenNietInSpakki = false;
			}

			simulatieDossierToUpdate.lengtegraad = lengtegraad;
			simulatieDossierToUpdate.breedtegraad = breedtegraad;
			const newCoordinates = Object.assign({}, { lat: breedtegraad, lng: lengtegraad });
			const center = Object.assign({}, { lat: parseFloat(breedtegraad), lng: parseFloat(lengtegraad) });

			const simulatieDossier = Object.assign({}, simulatieDossierToUpdate,
				{
					sportinfrastructurenOpKaart: sportinfrastructurenOpKaartReedsInProject,
					sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurtReedsInProject
				});

			this.context.props.storeSimulatieDossier(simulatieDossier);
			this.context.setState({
				simulatieDossier: simulatieDossier,
				newCoordinates,
				center
			});
		});
	}
}